'use strict';

import { HtmlImage as Image, SvgIconImage } from './image';

export { Image, SvgIconImage };
